export const SKU_LIST_G64000L: string[] = [
    "G64000L-Bl-S",
    "G64000L-Bl-M",
    "G64000L-Bl-L",
    "G64000L-Bl-XL",
    "G64000L-Bl-2XL",
    "G64000L-Bl-3XL",
    "G64000L-DaHe-S",
    "G64000L-DaHe-M",
    "G64000L-DaHe-L",
    "G64000L-DaHe-XL",
    "G64000L-DaHe-2XL",
    "G64000L-DaHe-3XL",
    "G64000L-San-S",
    "G64000L-San-M",
    "G64000L-San-L",
    "G64000L-San-XL",
    "G64000L-San-2XL",
    "G64000L-San-3XL",
    "G64000L-LiBl-S",
    "G64000L-LiBl-M",
    "G64000L-LiBl-L",
    "G64000L-LiBl-XL",
    "G64000L-LiBl-2XL",
    "G64000L-IrGr-S",
    "G64000L-IrGr-M",
    "G64000L-IrGr-L",
    "G64000L-IrGr-XL",
    "G64000L-IrGr-2XL",
    "G64000L-Pu-S",
    "G64000L-Pu-M",
    "G64000L-Pu-L",
    "G64000L-Pu-XL",
    "G64000L-Pu-2XL",
    "G64000L-Pu-3XL",
    "G64000L-Cha-S",
    "G64000L-Cha-M",
    "G64000L-Cha-L",
    "G64000L-Cha-XL",
    "G64000L-Cha-2XL",
    "G64000L-Wh-S",
    "G64000L-Wh-M",
    "G64000L-Wh-L",
    "G64000L-Wh-XL",
    "G64000L-Wh-2XL",
    "G64000L-Wh-3XL",
    "G64000L-Na-S",
    "G64000L-Na-M",
    "G64000L-Na-L",
    "G64000L-Na-XL",
    "G64000L-Na-2XL",
    "G64000L-Na-3XL",
    "G64000L-Re-S",
    "G64000L-Re-M",
    "G64000L-Re-L",
    "G64000L-Re-XL",
    "G64000L-Re-2XL",
    "G64000L-Re-3XL",
    "G64000L-Ro-S",
    "G64000L-Ro-M",
    "G64000L-Ro-L",
    "G64000L-Ro-XL",
    "G64000L-Ro-2XL",
    "G64000L-Ro-3XL",
    "G64000L-SpGr-S",
    "G64000L-SpGr-M",
    "G64000L-SpGr-L",
    "G64000L-SpGr-XL",
    "G64000L-SpGr-2XL",
    "G64000L-SpGr-3XL",
    "G64000L-AnSa-S",
    "G64000L-AnSa-M",
    "G64000L-AnSa-L",
    "G64000L-AnSa-XL",
    "G64000L-AnSa-2XL",
    "G64000L-Az-S",
    "G64000L-Az-M",
    "G64000L-Az-L",
    "G64000L-Az-XL",
    "G64000L-Az-2XL",
    "G64000L-AnChRe-S",
    "G64000L-AnChRe-M",
    "G64000L-AnChRe-L",
    "G64000L-AnChRe-XL",
    "G64000L-AnChRe-2XL",
    "G64000L-GrHe-S",
    "G64000L-GrHe-M",
    "G64000L-GrHe-L",
    "G64000L-GrHe-XL",
    "G64000L-GrHe-2XL",
    "G64000L-GrHe-3XL",
    "G64000L-Sky-S",
    "G64000L-Sky-M",
    "G64000L-Sky-L",
    "G64000L-Sky-XL",
    "G64000L-Sky-2XL",
    "G64000L-Sky-3XL",
    "G64000L-Hel-S",
    "G64000L-Hel-M",
    "G64000L-Hel-L",
    "G64000L-Hel-XL",
    "G64000L-Hel-2XL",
    "G64000L-Pis-S",
    "G64000L-Pis-M",
    "G64000L-Pis-L",
    "G64000L-Pis-XL",
    "G64000L-Pis-2XL",
    "G64000L-Pis-3XL",
    "G64000L-Par-S",
    "G64000L-Par-M",
    "G64000L-Par-L",
    "G64000L-Par-XL",
    "G64000L-Par-2XL",
    "G64000L-Par-3XL"
]